<microsec-loading-overlay [isLoading]="!!isLoading">
  @if (!!threat) {
    <microsec-selected-panel-header
      [id]="threat.threat_id"
      [label]="threat | threatTitlePipe"
      (closeSelectedPanelEvent)="hidePanelEvent.emit()"
      [rightTemplate]="rightTemplate" />
    <microsec-card [isDetailCard]="true">
      <p-tabs [value]="0" class="microsec-dashboard-tab">
        <p-tablist>
          <p-tab [value]="0">Threat Details</p-tab>
          <p-tab [value]="1">Mitigations</p-tab>
          <p-tab [value]="2">Comment</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <app-threat-overview [threat]="threat" />
          </p-tabpanel>
          <p-tabpanel [value]="1">
            <app-shared-mitigations [threat]="threat" />
          </p-tabpanel>
          <p-tabpanel [value]="2">
            <app-threat-comment [threat]="threat" />
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </microsec-card>
    <ng-template #rightTemplate>
      @if (!!threat?.is_pcap_available) {
        <div pTooltip="Download PCAP" tooltipPosition="top" appendTo="body">
          <p-button type="button" severity="primary" icon="fa fa-download" (onClick)="downloadPCAP()" />
        </div>
      }
    </ng-template>
  }
</microsec-loading-overlay>
